import { Skeleton } from '@mote/ui'
import { mediaBreakpointUp } from '@mote/ui/theme/core/breakpoints'
import styled from '@xstyled/styled-components'

export const StyledBackgroundSkeleton = styled(Skeleton)<{
  isAuthenticated: boolean
}>(
  {
    position: 'relative',
    width: '100%',
    height: 80,
    [mediaBreakpointUp('md')]: {
      height: 120
    }
  },
  props =>
    props.isAuthenticated && {
      borderRadius: 0,
      [mediaBreakpointUp('md-lg')]: {
        borderRadius: '1.5rem 0 0',
        '&:before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          height: '100%',
          left: 0,
          right: 0,
          zIndex: -1,
          backgroundColor: props.theme.colors.grey.l4
        }
      }
    }
)
